module.exports = __webpack_public_path__ + "img/chubb_logo.9ecfc91e.png";